import React from 'react';

import {
  Flex, Stack, Text, useToast,
} from '@chakra-ui/react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

import { login } from 'api/auth';
import { Input, Button, Checkbox } from 'components';
import { ContentRoutes } from 'enums/routes';
import useUser from 'stores/useUser';
import auth from 'validations/auth';

export default function Login() {
  const { push, location } = useHistory();
  const { set } = useUser();
  const toast = useToast();
  const form = useForm({
    mode: 'all',
    resolver: auth.login,
  });

  const state = location.state as { from?: string };

  const from = state?.from !== '/' ? state?.from : null;

  const {
    register, handleSubmit, setError, formState: { dirtyFields },
  } = form;
  const { mutate, isLoading } = useMutation(login, {
    onSuccess: ({ data, headers }) => {
      set({ user: data, token: headers.token });
      const next = from || `/table/${ContentRoutes.Routes}`;
      push(next);
    },
    onError: (error: any) => {
      if (error.errors) {
        error.errors.forEach((err) => {
          if (err.field) {
            setError(err.field, err);
          } else {
            setError(Object.keys(dirtyFields)[0], err);
          }
        });
      } else {
        toast({
          title: 'Ocorreu um erro.',
          description: error.message,
          status: 'error',
          duration: 5000,
          position: 'top-right',
          isClosable: true,
        });
      }
    },
  });

  const onSubmit = (data) => mutate({ data });

  return (
    <Stack
      width="100%"
      alignItems="center">
      <Text
        variant="2xLargeSemiBold"
        color="secondary.default">Bem vindo(a) de volta!
      </Text>
      <Text
        color="gray.500"
        textAlign="center"
        variant="mediumRegular">
        Insira seu email e a senha cadastrada para acessar a sua conta:
      </Text>
      <FormProvider {...form}>
        <Flex
          onSubmit={handleSubmit(onSubmit)}
          pt={6}
          width="100%"
          flexDir="column"
          as="form"
          justifyContent="space-between"
          flex={1}>
          <Stack
            pb={6}
            spacing={5}>
            <Input
              label="Email"
              {...register('email')}
            />
            <Input
              isSecure
              withSecureHelper
              label="Senha"
              {...register('password')}
            />
            <Checkbox
              {...register('rememberMeToken')}
              fontVariant="smallSemiBold">
              Continuar conectado
            </Checkbox>
          </Stack>
          <Button
            isLoading={isLoading}
            type="submit"
            size="xs"
            variant="primary.blue">
            <Text variant="smallBold">
              Entrar
            </Text>
          </Button>
        </Flex>
      </FormProvider>
    </Stack>
  );
}
